export const CONFIG_ENDPOINT = '/config.json';
export const PATIENT_DATA_ENDPOINT = '/patient-data';
export const ORGANIZATION_DATA_ENDPOINT = '/organization-data';
export const RESOURCES_DATA_ENDPOINT = '/resources-data';
export const USER_INFO_ENDPOINT = '/userinfo';
export const JWS_KEYS_ENDPOINT = '/certs';
export const AUTH_ENDPOINT = 'authorize';
export const STATE_STORAGE_KEY = 'oauth2-request-state';
export const LOGIN_ENDPOINT = 'login_transmuraal.html';
export const HEALTH_HUB_TOOLS_ENDPOINT = 'health_hub/index.html';
export const LOGOUT_ENDPOINT = 'uitgelogd.html';
export const REPORTS_ENDPOINT = '/reports';
export const SIMILAR_RESOURCE_SEARCH_ENDPOINT = '/similar-resource-search';